// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"bec15cf6","703":"4c4881a3"}[chunkId] + ".chunk.js";
};